import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';

const ITEMS = [
  { label: 'Cloud DNS', icon: 'ph-globe-hemisphere-west', path: '/cloud/dns' },
  { label: 'Health Check', icon: 'ph-heartbeat', path: '/cloud/health-checks' },
] as const;

/** Shared secondary (left) sidebar for the Cloud Management section. */
export function cloudSidebar(navigate: NavigateFunction, pathname: string) {
  return function CloudSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar title="Cloud Management" mobileExpanded={api.secondarySidebarExpanded} onClose={api.closeSecondarySidebar}>
        <SecondarySidebarSection title="Cloud Management" flush>
          <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
            {ITEMS.map((it) => (
              <li className="nav-item" key={it.path}>
                <a
                  href={it.path}
                  className={`nav-link ${pathname.startsWith(it.path) ? 'active' : ''}`.trim()}
                  onClick={(e) => {
                    e.preventDefault();
                    go(it.path);
                  }}
                >
                  <i className={`${it.icon} me-3`} />
                  {it.label}
                </a>
              </li>
            ))}
          </ul>
        </SecondarySidebarSection>
      </SecondarySidebar>
    );
  };
}
